module.exports = __webpack_public_path__ + "static/media/ricardo-gomez-angel-2oIgnII4f-0-unsplash -small-640.5501dc6f.jpg";